export const PHONE_REGEX = /^(((\+?64[3-9]|0[3-9])\d{7})|((\+?642\d{1}|02\d{1})\d{6,8})|(((\+?64800|0800)|(\+?64508|0508))\d{6,8}))$/

export const EMAIL_VALIDATION_REGEX = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/

// export const PHONE_VALIDATION_REGEX = /^[0-9_ ]{8,15}$/;
export const PHONE_VALIDATION_REGEX = /^(\+64|0)(\s|)(2|3|4|6|7|8|9)[0-3,6-9]{0,1}(\s|)\d{3,4}(\s|)\d{3,4}$/gm

export const NUMBER_ONLY_REGEX = /^[0-9]+$/

export const CURRENCY_ONLY_REGEX = /^[+-]?[0-9]{1,3}(?:,?[0-9]{3})*\.[0-9]{2}$/

export const IPV4_VALIDATION_REGEX = /^((25[0-5]|(2[0-4]|1\d|[1-9]|)\d)\.?\b){4}$/

export const PASSWORD_COMPLEXITY_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d@$!%*#?&^_-]{8,32}$/

export const CID_ACCOUNT_REGEX = /^[0-9]{4}$/
